// Runtime environment configuration
// All values are injected via window._env_ from /scripts/env-config.js
// which is generated by env.sh at container startup

const getEnvValue = (key: string, fallback: string): string => {
  if (typeof window !== 'undefined' && window._env_ && window._env_[key]) {
    return window._env_[key];
  }
  return fallback;
};

const isProduction = (): boolean => {
  if (typeof window !== 'undefined' && window._env_ && window._env_.production !== undefined) {
    return window._env_.production === 'true' || window._env_.production === true;
  }
  return true;
};

export const environment = {
  production: isProduction(),
  apiUrl: getEnvValue('apiUrl', 'http://localhost'),
  metaDataURL: getEnvValue('metaDataURL', 'https://s3.amazonaws.com/teradix-assets/development'),
  dashboardURL: getEnvValue('dashboardURL', 'http://localhost:4200'),
  S3URL: getEnvValue('S3URL', 'https://teradix-general.s3.amazonaws.com/')
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
